import { FC } from 'react';
import { Location, Navigate, Outlet, useLocation } from 'react-router-dom';
import { User } from '../../utils/models';

import auth from '../../services/authService';

interface RoleBasedRouteProps {
	userType: User['userType'];
	redirectPath: string;
}

const UserBasedRoute: FC<RoleBasedRouteProps> = (props): JSX.Element => {
	const user = auth.getCurrentUser() as User;
	const location: Location = useLocation();

	const isPermitted: boolean = user.userType === props.userType;
	if (isPermitted) return <Outlet />;

	return (
		<Navigate to={props.redirectPath} state={{ from: location.pathname }} />
	);
};

export default UserBasedRoute;
